import React from 'react';
import { v4 as uuid } from 'uuid';

import './selector.styles.css';

const Selector = ({
	name,
	title,
	options,
	value,
	onChange,
	backgroundColor,
	isAbsolute,
	smallFont,
}) => {
	const extraStyles = {
		backgroundColor: backgroundColor ? backgroundColor : 'rgba(0,0,0,0)',
		position: isAbsolute ? 'absolute' : 'static',
		fontSize: smallFont ? '12px' : '16px',
	};
	return (
		<>
			<div className='selectorContainer' style={extraStyles}>
				<div className='selectorLabel'>{title}: </div>
				{options.map((option) => (
					<div key={uuid()} className='floatBlock'>
						<label htmlFor={option.name}>
							<input
								id={option.name}
								type='radio'
								value={option.name}
								name={name}
								checked={value.toString() === option.name.toString()}
								onChange={onChange}
							/>{' '}
							{option.label}
						</label>
					</div>
				))}
			</div>
		</>
	);
};

export default Selector;
